import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Lookup } from 'src/app/models/lookups/Lookup';
import { AmbassadorVolunteeringExperience } from 'src/app/models/user/AmbassadorVolunteeringExperience';
import { AmbassadorsProfileService } from 'src/app/services/ambassadors-profile.service';
import { LookupsService } from 'src/app/services/lookups.service';
import Swal from 'sweetalert2';
export interface DialogData {
  record: AmbassadorVolunteeringExperience;
}
@Component({
  selector: 'app-volunteering-experiences-form',
  standalone: false,
  templateUrl: './volunteering-experiences-form.component.html'
})
export class VolunteeringExperiencesFormComponent implements OnInit {
  loading = false
  formGroup!: FormGroup
  monthsList: Lookup[] = []
  yearsList: Lookup[] = []
  @ViewChild('form') form!: NgForm;
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<VolunteeringExperiencesFormComponent>,
    private service: AmbassadorsProfileService,
    private lookupsService: LookupsService,
    private translate: TranslateService
  ) { }
  ngOnInit(): void {
    this.getMonths()
    this.generateYears()
    this.initForm()
    if (this.data.record) {
      this.bindData(this.data.record)
    }
    this.formGroup.get('currentlyVolunteering')?.valueChanges.subscribe(value => {
      this.updateEndDateState(value);
    });
  }
  bindData(record: AmbassadorVolunteeringExperience) {
    this.formGroup.patchValue(
      record, { emitEvent: true }
    )
    this.updateEndDateState(record.currentlyVolunteering);
  }

  getMonths() {
    this.lookupsService.getMonths().subscribe(res => {
      this.monthsList = res
    }, err => {

    })
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 50;

    this.yearsList = Array.from({ length: 51 }, (_, i) => {
      const year = currentYear - i;
      return { id: year, name: year.toString() };
    });
  }

  initForm() {
    this.formGroup = this.fb.group({
      rolePosition: ['', {
        validators: [
          Validators.required,
        ]
      }],
      organizationName: ['', {
        validators: [
          Validators.required,
        ]
      }],

      startDate: this.fb.group({
        month: ['', [Validators.required]],
        year: ['', [Validators.required]]
      }),

      endDate: this.fb.group({
        month: ['', [Validators.required]],
        year: ['', [Validators.required]]
      }),

      currentlyVolunteering: [false]
    }, { validators: this.dateRangeValidator });
  }


  handelEndDateValue(event) {
    const endDateGroup = this.formGroup.get('endDate');
    const monthControl = endDateGroup?.get('month');
    const yearControl = endDateGroup?.get('year');

    if (event.checked) {
      monthControl?.setValue(null);
      yearControl?.setValue(null);

      monthControl?.clearValidators();
      yearControl?.clearValidators();
    } else {
      monthControl?.setValidators([Validators.required]);
      yearControl?.setValidators([Validators.required]);
    }

    monthControl?.updateValueAndValidity();
    yearControl?.updateValueAndValidity();
  }

  dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const startGroup = control.get('startDate');
    const endGroup = control.get('endDate');
    const currentlyVolunteering = control.get('currentlyVolunteering')?.value;

    if (!startGroup || !endGroup || currentlyVolunteering) {
      return null;
    }

    const startYear = +startGroup.get('year')?.value;
    const startMonthId = +startGroup.get('month')?.value;
    const endYear = +endGroup.get('year')?.value;
    const endMonthId = +endGroup.get('month')?.value;

    if (!startYear || !endYear || !startMonthId || !endMonthId) {
      return null;
    }


    const startDate = new Date(startYear, startMonthId - 1);
    const endDate = new Date(endYear, endMonthId - 1);
    return endDate < startDate ? { dateRangeInvalid: true } : null;
  }



  updateEndDateState(iscurrentlyVolunteering: boolean) {
    const endDateGroup = this.formGroup.get('endDate');
    if (iscurrentlyVolunteering) {
      endDateGroup?.disable();
    } else {
      endDateGroup?.enable();
    }
  }


  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true
      let formControls = this.formGroup.value
      if (this.data.record) formControls.id = this.data.record.id
      this.service.AddOrUpdateAmbassadorVolunteeringExperience(formControls).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.success'),
          text: this.data.record ? this.translate.instant('swalMsg.updatedsuccessfully') : this.translate.instant('swalMsg.addedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.ok')
        });
        this.dialogRef.close(true)
      }, error => {
        this.loading = false;

        if (error && error.detail) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.ok')
          });
        }
      });

    }
  }

  hasError(controlName: string, errorName: string, groupName?: string): boolean {
    const path = groupName ? `${groupName}.${controlName}` : controlName;
    const control = this.formGroup.get(path);

    return !!(control && control.hasError(errorName) && (control.touched || this.form?.submitted));
  }
}
